import type { FaireProductEntity } from "../../entity_types/product";

export const p_dpyp6s7cy3: FaireProductEntity = {
  token: "p_dpyp6s7cy3",
  type: "product",
  name: "Sweet Treat Double Jar",
  brandToken: "b_vaddvj6a8j",
  brandName: "For the Love of Dough Co",
  imageUrl:
    "https://cdn.faire.com/fastly/9e468253dfdde99ca35a1181b7f99183b304a8b4f2007e88bb2eeefccdb913e3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3c057b8164cab083ca157e6c437ceeb49e8ff5ba9e072ee50b49133d09310ab.jpeg",
  ],
  priceDollars: 8.49,
  description:
    "Craft imaginative confections using this comprehensive kit, which includes sprinkle-infused homemade play dough and all the tools necessary to design delightful edible-looking creations. Perfect for creative play and sensory exploration.\n\n\n\n\n\n\n\nWarning: Contains small parts; not intended for children under 3.\n\nAllergen Notice: Contains Wheat, may contain soy, corn derivatives\n\nAdult supervision suggested.\n\nFor questions and assistance:\n\nFor the Love of Dough\n\n[redacted-email]\n\n\n\nDough storage: It is hard to completely put a time on how long your fresh play dough will last. But if kept sealed tight in its container after use it should stay fresh and soft for several months.\n\nOur play dough is made to order and perishable. We are unable to offer cancellations or accept returns. Should you have any issues with your order, please contact us!\n",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:38.550Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
